export const SPACEBAR_KEY_CODE = 32;
export const TAB_KEY_CODE = 9;
export const ARROW_KEY_DOWN_CODE = 40;
export const ARROW_KEY_UP_CODE = 38;
export const ENTER_KEY_CODE = 13;
export const ESC_KEY_CODE = 27;
export const BACKSPACE_KEY_CODE = 8;
